import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as a } from "../../../../IconBase-CxZyIWw2.js";
const s = r((i, e) => /* @__PURE__ */ l.jsx(
  a,
  {
    ref: e,
    ...i,
    image: (o) => /* @__PURE__ */ l.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...o,
        children: [
          /* @__PURE__ */ l.jsx("g", { clipPath: "url(#clip0_3410_69083)", children: /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M5.679.43A1 1 0 0 1 6.5 0h3a1 1 0 0 1 .8.4L11.5 2H13a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h1.588zM6 4v2h4V4z",
              clipRule: "evenodd"
            }
          ) }),
          /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "clip0_3410_69083", children: /* @__PURE__ */ l.jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
        ]
      }
    )
  }
));
s.displayName = "ClipboardIcon";
export {
  s as ClipboardIcon,
  s as default
};
//# sourceMappingURL=index.js.map
